module.exports = __webpack_public_path__ + "img/select.5fe74829.png";